<template>
  <v-dialog v-model="value" persistent max-width="500">
    <v-card>
      <v-card-title class="title font-weight-regular">
        <v-icon left color="black">mdi-account-plus</v-icon>
        {{ $t("KULLANICILAR.CHANGE_PASSWORD.TITLE") }}
      </v-card-title>
      <v-card-text>
        <v-divider />
        <v-text-field v-model="sifreData.sifre" prepend-icon="mdi-key" type="password" :label="$t('KULLANICILAR.CHANGE_PASSWORD.PASSWORD_LABEL')"></v-text-field>
        <v-text-field
          v-model="sifreData.sifreTekrar"
          prepend-icon="mdi-key"
          type="password"
          :label="$t('KULLANICILAR.CHANGE_PASSWORD.PASWORD_AGAIN_LABEL')"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" class="mr-1" text @click="dialogKapat">
          {{ $t("KULLANICILAR.CHANGE_PASSWORD.CANCEL_BTN") }}
        </v-btn>
        <v-btn color="success" dark :loading="sifreDegistirStatus" @click="sifreDegistir">
          <v-icon left>mdi-plus-circle</v-icon>
          {{ $t("KULLANICILAR.CHANGE_PASSWORD.UPDATE_PASSWORD_BTN") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import KullanicilarService from "@/services/KullanicilarService";

export default {
  name: "SifreDegistir",
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    },
    id: {
      required: true
    }
  },
  data: () => ({
    sifreData: {
      sifre: "",
      sifreTekrar: ""
    },
    sifreDegistirStatus: false
  }),
  methods: {
    sifreDegistir() {
      const { sifre, sifreTekrar } = this.sifreData,
        kullaniciID = this.id;

      KullanicilarService.sifreDegistir({
        kullaniciID,
        sifre,
        sifreTekrar
      }).then(res => {
        if (res.status === 200) {
          this.$snotify.success(this.$t("KULLANICILAR.NOTIFY.UPDATE_PASSWORD_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          this.dialogKapat();
        } else this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
      });
    },
    dialogKapat() {
      this.dialogSifirla();
      this.$emit("input", false);
    },
    dialogSifirla() {
      this.sifreData.sifre = "";
      this.sifreData.sifreTekrar = "";
      /**
       * Dialog sıfırlandığında bir event tetikle
       */
      this.$emit("update", this);
    }
  }
};
</script>

<style></style>
